import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  StyledEvent,
  FirstElementEvent,
  StyledIcons,
  StyledLayer,
  StyledLayerShort,
  StyledName,
  StyledDayHours,
  StyledCourse,
  StyledBoxInterior,
  StyledBoxInteriorButtonMessage,
  StyledIconOk,
  StyledText,
  ButtonsEvent,
  StyledCheck,
  StyledBoxDown,
  StyledLink,
  StyledIconCollapseDown
} from './styleEvent';

import { Colapse, Geo, Ok } from '../../../../assets/images/index';

import { Paginator } from '../Paginator';
import Icon from '../Icon';

const EventNotifications = ({ dataMeeting }) => {
  const eventMeeting = item => (
    <StyledEvent acceptedEvent={item.accepted} tabIndex="0">
      <FirstElementEvent>
        <StyledIcons
          size="m"
          color={item.accepted ? 'grayDarker' : 'light'}
          svg={Geo}
        />
        <StyledLayerShort>
          <StyledName>{item.title}</StyledName>
          <StyledCourse>{item.place}</StyledCourse>
          <StyledIconCollapseDown color="primary" size="s" svg={Colapse} />
        </StyledLayerShort>
      </FirstElementEvent>
      <StyledLayer>
        <StyledDayHours>{item.date}</StyledDayHours>
      </StyledLayer>
      <StyledLayer>
        <StyledDayHours>{item.hour}</StyledDayHours>
      </StyledLayer>
      {item.accepted ? (
        <StyledBoxInterior>
          <StyledIconOk size="m" color="light" svg={Ok} />
          <StyledText>El evento ha sido añadido a tu calendario</StyledText>
        </StyledBoxInterior>
      ) : (
        <StyledBoxInteriorButtonMessage>
          <ButtonsEvent ghost>Aceptar</ButtonsEvent>
          <ButtonsEvent ghost>Rechazar</ButtonsEvent>
          <ButtonsEvent ghost>Ver</ButtonsEvent>
          {item.check && (
            <StyledCheck>
              Leído
              <Icon size="s" color="light" svg={Ok} />
            </StyledCheck>
          )}
        </StyledBoxInteriorButtonMessage>
      )}
    </StyledEvent>
  );
  return (
    <Fragment>
      {dataMeeting.map((item, index) => {
        const event = index < 3 && eventMeeting(item);
        return event;
      })}
      <StyledBoxDown>
        <StyledLink>Ir a la App</StyledLink>
        {dataMeeting.length > 3 && (
          <Paginator pages={dataMeeting.length / 3} color="light" />
        )}
      </StyledBoxDown>
    </Fragment>
  );
};

EventNotifications.propTypes = {
  dataMeeting: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      place: PropTypes.string,
      date: PropTypes.string,
      hour: PropTypes.string,
      accepted: PropTypes.bool,
      check: PropTypes.bool
    })
  )
};

export default EventNotifications;
